// employee-career-path.component.ts
import { AfterContentChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Department } from './models/department.model';
import { PracticePath } from './models/practice-path.model';
import { EmployeeModel } from 'src/app/Models/EmpCareerUser.model';
import { CareerPathService } from './employee-career-path.service';
import { FormBuilder } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { AllCareerSearch } from './models/all-career-search.model';
import { numbers } from '@material/dialog';

@Component({
  selector: 'app-employee-career-path',
  templateUrl: './employee-career-path.component.html',
  styleUrls: ['./employee-career-path.component.css']
})
export class EmployeeCareerPathComponent implements OnInit, AfterContentChecked {

  practices: any[];
  departments: Department[];
  searchForm: any;
  practicePaths: PracticePath[];
  myPracticePath: PracticePath[];
  selectedDepartmentName: string = '';
  selectedPracticeName: string = '';
  employeeDetails: EmployeeModel;
  first: string = '';
  last: string = '';
  myDepartment: any;
  isSideBarOpened = true;

  isAllCareers = false;
  selectedListItem: number;
  selectedItems = new Map<string, number>();
  selectedItem: any = null;

  selectedPracticeId: number;
  selectedDepartmentId: number;
  selectedDepartmentPathId: number;

  loading: boolean = false;
  isCareerPathLoading: boolean = false;

  filteredPractices: any;
  txt: string = '';
  approvedCertifications: string = "https://acsicorp.sharepoint.com/sites/CoP/Lists/Approved%20Certifications/AllItems.aspx?ovuser=7896c5aa%2D71b4%2D47c3%2D98d4%2De707bdd7462f%2Cshivakanth%2Epilly%40acsicorp%2Ecom&OR=Teams%2DHL&CT=1722419988928&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNDA2MjcyNDgxNCIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D";

  constructor(private service: CareerPathService,
    private formbuilder: FormBuilder, private spinnerService: NgxSpinnerService, private cdRef: ChangeDetectorRef, private snackbar: MatSnackBar, private activatedRoute: ActivatedRoute) {
    // this.employeeDetails = this.authService.getUserInfo();
    const storedData = localStorage.getItem('empCareerUserDetails');
    this.employeeDetails = JSON.parse(storedData);
    this.selectedPracticeName = this.employeeDetails?.practice;
    this.selectedDepartmentName = this.employeeDetails?.department;
    this.selectedItem = this.employeeDetails?.department;
  }
  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  PracticeCanceled() {
    this.searchForm.get('practiceId').setValue(null);
    this.searchForm.get('departmentIds').setValue(null);
    this.practicePaths = [];
  }

  ngOnInit(): void {
    this.isCareerPathLoading = true;
    this.searchForm = this.formbuilder.group({
      searchText: this.formbuilder.control(null),
      practiceId: this.formbuilder.control(null),
      departmentIds: this.formbuilder.control([])
    });
    this.spinnerService.show();
    this.service.getAllPracticesAndDepartments().subscribe((res: any) => {
      this.practices = res;
      this.filteredPractices = this.practices.map((practice) => {
        return {
          practiceID: practice?.practiceID,
          practiceName: practice.practiceName,
          departments: [...practice.departments]
        }
      });
      this.spinnerService.hide();

      let searchModel: AllCareerSearch = {
        practiceId: this.employeeDetails?.practiceId,
        searchText: '',
        departmentIds: [this.employeeDetails?.departmentId]
      }
      // this.spinnerService.show();
      this.loading = true;
      this.practicePaths = [];
      this.service.get(searchModel).subscribe((res: PracticePath[]) => {
        if (res.length > 0) {
          this.practicePaths = [...res];
          this.isCareerPathLoading = false;
          this.cdRef.detectChanges();
          this.loading = false;
          // this.spinnerService.hide();
        } else {
          this.practicePaths = [];
          this.isCareerPathLoading = false;
          this.cdRef.detectChanges();
          this.loading = false;
          // this.spinnerService.hide();
        }
      });
    this.loading = false;
     this.spinnerService.hide();
    });
    
      this.spinnerService.hide();
       this.loading = false;
    // this.activatedRoute.data.subscribe(({ practicePaths }) => {
    //   if (practicePaths.length > 0) {
    //     this.practicePaths = [...practicePaths];
    //   } else {
    //     this.practicePaths = [];
    //   }
    // })


  }

  reset() {
    this.searchForm.reset();
  }

  departmentCanceled(departmentName: string) {
    this.searchForm.get('departmentIds').setValue(null);
    this.practicePaths.map(results => results.departmentPaths = results.departmentPaths.filter(item => item.name !== departmentName))
  }

  getDepatments() {
    return this.searchForm.controls['departmentIds']?.value;
  }

  isPracticeSelected() {
    return this.searchForm.controls['practiceId']?.value;
  }

  isDepartmentSelected() {
    return this.searchForm.controls['departmentIds']?.value?.length >= 1;
  }

  isFreeTextSelected() {
    return this.searchForm.controls['searchText'].value;
  }

  onPracticeChange() {
    this.departments = [];

    const practiceId = this.searchForm.get('practiceId')?.value
    if (practiceId) {
      this.spinnerService.show();
      this.service.getDepartments(practiceId).subscribe((res: Department[]) => {
        this.departments = res;
        this.spinnerService.hide();
      });
    }
    this.spinnerService.hide();
    this.loading = false;
  }

  getDepartments(practice) {
    if (practice.id) {
      this.spinnerService.show();
      this.service.getDepartments(practice.id).subscribe((res: Department[]) => {
        this.departments = res;
        this.spinnerService.hide();
      });
    }
    this.spinnerService.hide();
    this.loading = false;
  }

  canSearch(): boolean {
    const formValue = this.searchForm?.value
    if (formValue.searchText || formValue.practiceId) {
      return true;
    }
    else {
      return false;
    }
  }

  onTabChanged(event) {
    if (event.index == 1) {
      this.isAllCareers = true;
    } else {
      this.isAllCareers = false;
    }
  }

  getGraphData() {
    return [...this.practicePaths[0]?.departmentPaths[0]?.roles];
  }

  isSelected(department) {
    
    return this.selectedItem && this.selectedItem === department.departmentName;
  }

  getCareerPath(practice, department) {
    this.isCareerPathLoading = true;
    this.selectedDepartmentId = department.departmentID;
    this.selectedPracticeId = practice.practiceID;
    this.selectedDepartmentPathId = 0;

    this.selectedItem = department.departmentName;

    this.selectedPracticeName = practice.practiceName;
    this.selectedDepartmentName = department.departmentName;
    let searchModel: AllCareerSearch = {
      practiceId: practice.practiceID,
      searchText: '',
      departmentIds: [department.departmentID]
    }
    this.practicePaths = [];
    // this.spinnerService.show();
    //this.loading = true;
    this.service.get(searchModel).subscribe((res: PracticePath[]) => {
      if (res.length > 0) {
        this.practicePaths = [...res];
        this.isCareerPathLoading = false;
        this.cdRef.detectChanges();
        this.loading = false;
        // this.spinnerService.hide();
      } else {
        this.practicePaths = [];
        this.isCareerPathLoading = false;
        this.cdRef.detectChanges();
        this.loading = false;
        // this.spinnerService.hide();
      }
    });
   
    this.spinnerService.hide();
    this.loading = false;
  }

  onOpenedChange(event) {
    this.isSideBarOpened = event;
  }

  requestCarrerPathChange() {
    let config = new MatSnackBarConfig();
    config.verticalPosition = 'top';
    config.horizontalPosition = 'right';
    config.duration = 3000;
    this.spinnerService.show();
    var requestedProgram = {
      UserId: this.employeeDetails.userID,
      ProgramId: 0,
      RequestStatusID: 3,
      Type: 2,
      PracticeID: this.selectedPracticeId,
      DepartmentID: this.selectedDepartmentId,
      DepartmentPathID: this.selectedDepartmentPathId
    };
    this.service.addCareerPathRequest(requestedProgram).subscribe(res => {
      this.spinnerService.hide();
      if (res) {
        config.panelClass = ['success'];
        this.snackbar.open('Request Success!', 'x', config);
      }
      else {
        config.panelClass = ['error'];
        this.snackbar.open('Request Failed!', 'x', config);
      }
    }, error => {
      this.spinnerService.hide();
      config.panelClass = ['error'];
      this.snackbar.open('Request Failed!', 'x', config);
    });
     this.spinnerService.hide();
     this.loading = false;
  }

  searchSubCompetency(inputSearch: string, practice: any) {
    let filteredDept = practice.departments.filter((dept) => {
      return dept.departmentName.toLowerCase().includes(inputSearch.toLowerCase())
    });
    return filteredDept.length > 0 ? {
      ...practice,
      departments: filteredDept
    } : null

  }
  searchCompetency(inputSearch: string, practice: any) {
    practice = practice.practiceName.toLowerCase().includes(inputSearch.toLowerCase()) ? practice : null;
    return practice;
  }

  search(event: any) {
    this.txt = event
    this.filteredPractices = [];
    let f = this.practices.map((practice: any) => {
      let k = this.searchCompetency(event, practice)
      let y = this.searchSubCompetency(event, practice)
      k ? this.filteredPractices.push(k) : (y ? this.filteredPractices.push(y) : '')
    });
  }

}
